"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _styles = require("@material-ui/core/styles");
var _reactSvgIcon = require("@micado-digital/react-svg-icon");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => {
  var _theme$palette, _theme$palette2, _theme$palette3, _theme$transitions, _theme$transitions2, _theme$palette4, _theme$typography;
  return {
    root: {
      display: "flex",
      "& a": {
        color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.text) === null || _theme$palette === void 0 ? void 0 : _theme$palette.primary,
        display: "flex"
      },
      "& a:hover": {
        color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 || (_theme$palette2 = _theme$palette2.secondary) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.main
      },
      "& svg": {
        margin: theme.spacing(0, 2, 0, 0)
      }
    },
    link: {
      "& svg path:first-child": {
        fill: (_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 || (_theme$palette3 = _theme$palette3.primary) === null || _theme$palette3 === void 0 ? void 0 : _theme$palette3.main,
        transition: theme.transitions.create("fill", {
          easing: (_theme$transitions = theme.transitions) === null || _theme$transitions === void 0 || (_theme$transitions = _theme$transitions.easing) === null || _theme$transitions === void 0 ? void 0 : _theme$transitions.easeInOut,
          duration: (_theme$transitions2 = theme.transitions) === null || _theme$transitions2 === void 0 || (_theme$transitions2 = _theme$transitions2.duration) === null || _theme$transitions2 === void 0 ? void 0 : _theme$transitions2.shorter
        })
      },
      "&:hover": {
        "& svg path:first-child": {
          fill: (_theme$palette4 = theme.palette) === null || _theme$palette4 === void 0 || (_theme$palette4 = _theme$palette4.secondary) === null || _theme$palette4 === void 0 ? void 0 : _theme$palette4.main
        }
      }
    },
    title: {
      fontWeight: (_theme$typography = theme.typography) === null || _theme$typography === void 0 ? void 0 : _theme$typography.fontWeightBold
    }
  };
});
const Download = _ref => {
  let {
    data
  } = _ref;
  const {
    title,
    media
  } = data;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  if (!(media !== null && media !== void 0 && media.length) > 0) {
    return null;
  }
  const formatSize = function (bytes) {
    let decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  const detectIconFromFilename = filename => {
    const iconWidth = 40;
    switch (filename.split(".").pop()) {
      case "doc":
      case "docx":
        return /*#__PURE__*/_react.default.createElement(_reactSvgIcon.ReactSVGIcon, {
          src: "".concat(REACT_APP_PATH, "/img/icons/file-word.svg"),
          color: "initial",
          size: iconWidth
        });
      case "xls":
      case "xlsx":
        return /*#__PURE__*/_react.default.createElement(_reactSvgIcon.ReactSVGIcon, {
          src: "".concat(REACT_APP_PATH, "/img/icons/file-excel.svg"),
          color: "initial",
          size: iconWidth
        });
      case "pdf":
        return /*#__PURE__*/_react.default.createElement(_reactSvgIcon.ReactSVGIcon, {
          src: "".concat(REACT_APP_PATH, "/img/icons/file-pdf.svg"),
          color: "initial",
          size: iconWidth
        });
      case "jpg":
      case "gif":
      case "tiff":
      case "tif":
      case "png":
        return /*#__PURE__*/_react.default.createElement(_reactSvgIcon.ReactSVGIcon, {
          src: "".concat(REACT_APP_PATH, "/img/icons/file-image.svg"),
          color: "initial",
          size: iconWidth
        });
      case "rar":
      case "tar":
      case "zip":
      case "7zip":
        return /*#__PURE__*/_react.default.createElement(_reactSvgIcon.ReactSVGIcon, {
          src: "".concat(REACT_APP_PATH, "/img/icons/file-zip.svg"),
          color: "initial",
          size: iconWidth
        });
      default:
        return /*#__PURE__*/_react.default.createElement(_reactSvgIcon.ReactSVGIcon, {
          src: "".concat(REACT_APP_PATH, "/img/icons/file.svg"),
          color: "initial",
          size: iconWidth
        });
    }
  };
  const {
    filename,
    size
  } = (0, _lodash.first)(media);
  const filesizeFormatted = size ? formatSize(size) : "";
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 6,
    className: css.root
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: css.link,
    href: REACT_APP_PATH + filename,
    style: {
      alignItems: "center"
    },
    target: "_top"
  }, detectIconFromFilename(filename), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: css.title,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), filesizeFormatted ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "caption",
    style: {
      marginRight: 16
    }
  }, filesizeFormatted) : "")));
};
var _default = exports.default = Download;